import {Injectable} from '@angular/core';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class ErrorService {

  constructor(
    private router: Router
  ) {
  }

  errorHandlerOnGetDetailOfLoan(err) {
    if (err.error.errorType === 'GENERIC') {
      if (err.status === 404) {
        this.router.navigate(['/error']);
      }
    }
    if (err.error.errorType === 'VALIDATION') {
    }
  }
}
